import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { HttpClientService } from '../../../shared/services/http-client.service';
import { Util } from '../../../shared/util';
import { Http, Response } from '@angular/http';


@Injectable()
export class DashboardService {

  constructor(
    private httpService: HttpClientService,
  ) { }

  /**
   * kaushalya
   * @param body 
   * get interview details according to daterange
   */
  getInterviewDetailsByDateRange(body: any) {
    return this.httpService.post('jobInterview/interviewDetailsByDateRange', body);
  }

  /**
   * kaushalya
   * @param body 
   * get google doc details according to folder id
   * 2017-07-20
   */
  getAvailableCvs(body: any) {
    return this.httpService.post('googleApi/folderContent', body);
  }

  /**
   * kaiuhsalya
   * @param body
   * get pending leave list according to date range 
   * 2017-07-21
   */
  getPendingLeave(body: any) {
    return this.httpService.post('leave/LeaveListAccordingtoDateRange', body);
  }

  /**
   * kauhslya
   * @param body
   * get holiday list 
   * 2017-07-24
   */
  getHolidayList(body: any) {
    return this.httpService.post('holiday/holidayList', body);
  }

  /**
   * kauhslya
   * @param body
   * get pending attendance details and leave details
   * 2017-07-25
   */
   getPendingAttendanceAndLeave(body: any) {
    return this.httpService.post('attendance/pendingPunchIn', body);
  }

  /**
   * kauhslya
   * @param body
   * get attendance details according to employee is and date
   * 2017-07-28
   */
   getAttendanceByEmpIdAndDate(body: any) {
    return this.httpService.post('attendance/punchInAndOutAccordingtoEmpAndDate', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/services/dashboard.service.ts